<template>
  <div class="video-with-thumbnail">
    <div class="thumb-pic-overlay" v-if="!videoPlaying && video">
      <div class="thumb-pic-play-icon" @click="playVideoInThumbnail(id, true)"></div>
    </div>

    <div
      :class="{
        'thumb-video-box': hidePosterOnLargeScreens,
        'thumb-image-box': !hidePosterOnLargeScreens
      }"
    >
    <video
          :ref="id"
          :src="`${video}`"
          :poster="imageUrl"
          @ended="handleVideoEnd"
          @timeupdate="updateBar"
        />
        <div class="controlsRootCon" v-if="videoPlaying">
          <div class="controlsCon">
            <div>
              <i
                v-if="videoPaused"
                @click="play"
                class="fa fa-play control-btn"
                style="color: white;font-size: 24px; cursor: pointer;"
              ></i>
              <i
                v-else
                class="fa fa-pause control-btn"
                @click="pause"
                style="color: white; font-size: 24px;cursor: pointer;"
              ></i>
            </div>
            <div class="bar" @mousedown="pause" @mouseup="play" @touchstart="pause" @touchend="play">
              <el-slider
                v-model="progressBarVal"
                :min="0"
                :max="100"
                @change="handleTimeChange"
                :show-tooltip="false"
              ></el-slider>
            </div>
          </div>
        </div>
    </div>

    <div
      v-if="posterImage && !video"
      :class="{
        'thumb-image-box': true,
        'hide-on-lg': hidePosterOnLargeScreens,
        hiddenTransparent: videoPlaying
      }"
      :style="{ 'background-image': 'url(' + posterImage + ')' }"
    ></div>
  </div>
</template>

<script>
import config from '@/config'

export default {
  name: 'custom-player',
  props: {
    showDownload:{
      type:Boolean,
      default:false,
    },
    id: {
      type: String,
      default: 'videoRef'
    },
    video: {
      type: String,
      required: false,
      default: ''
    },
    hidePosterOnLargeScreens: {
      type: Boolean,
      required: false,
      default: false
    },
    posterImage: {
      type: String,
      required: false
      // default: config.DEFAULT_PROFILE_PIC
    },
  },
  data: function() {
    return {
      videoPlaying: false,
      videoPaused: true,
      progressBarVal: 0,
    }
  },
  computed: {
    imageUrl: function() {
      if (this.posterImage) {
        return this.posterImage
      }
      if (!this.video) {
        return config.DEFAULT_PROFILE_PIC
      }
    },
    VP:function() {
      return this.$refs[this.id]
    }
  },
  methods: {
    playVideoInThumbnail(id, playNow) {
      this.videoPaused = false
      this.videoPlaying = playNow
      if (playNow) {
        this.VP.play()
      }
    },
    play() {
      this.VP.play()
      this.videoPaused = false
    },
    pause() {
      this.VP.pause()
      this.videoPaused = true
    },
    updateBar() {
      let percentage = Math.floor((100 / this.VP.duration) * this.VP.currentTime)

      this.progressBarVal = percentage
    },
    handleTimeChange(val) {
      if (!this.videoPaused) {
        this.pause()
      }
      this.VP.currentTime = (val / 100) * this.VP.duration
      this.play()
    },
    handleClose() {
      this.VP.currentTime = 0
      this.pause()
      this.modalVisible = false
    },
    handleVideoEnd() {
      this.VP.currentTime = 0
      this.pause()
    }
  }
}
</script>

<style lang="scss" scoped>
.controlsRootCon {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 10%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.controlsCon {
  display: flex;
  width: 80%;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.bar {
  flex: 1;
}

@media (max-width:767px) {
  .controlsCon {
    gap:12px;
  }
  .control-btn {
    font-size: 14px !important;
  }
  }

.el-slider__runway {
        margin: 0px !important;
        background-color: #32a19c !important;
      }

      .el-slider__bar {
        background-color: #ffffff;
      }

      .el-slider__button {
        border: solid 4px #ffffff;
        background-color: #f79f1f;
      }

video {
  height: inherit;
}
.thumb-pic-play-icon {
  z-index: 11;
}
.thumb-video-box {
  width: 100%;
  height: 100%;
  video {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
}
.hide-on-lg {
  @media screen and (min-width: 768px) {
    display: none;
  }
}
</style>
